import React from 'react';
import PropTypes from 'prop-types';
import { Column } from 'web-ui-components/lib/global/layout';
import { isEmpty, get, find, map, head } from 'lodash';
import { getAccountDisplayNumber } from '../../../businessLogic/AccountsBL';
import { AccountSummaryLinkCard } from 'web-ui-components/lib/molecules/cards';

export const formatAmount = (amount) => {
  if (amount !== '') {
    return Number.parseFloat(amount).toLocaleString('en-GB', { minimumFractionDigits: 2 });
  }
  return amount;
};

export const getBalance = (balances) => {
  const current = find(balances, { type: 'current' });
  const available = find(balances, { type: 'available' });
  return {
    currentBalance: formatAmount(get(current, 'amount.value', '')),
    availableBalance: formatAmount(get(available, 'amount.value', '')),
  };
};

const AccountCardComponent = ({ accountData, onAccountClick }) => {
  return (
    <Column className="u-margin-top-1 u-margin-bottom-1">
      {map(accountData, (accounts) => {
        let accountNo;
        let displayName;
        const { metadata, product, balances } = accounts;
        const getBalanceOf = getBalance(balances);
        const showAvailableBalance = get(head(accountData), '/account/balance/available');
        if (accounts && !isEmpty(accounts)) {
          displayName = metadata.display_name;
          accountNo = getAccountDisplayNumber(accounts);
          if (displayName === null || isEmpty(displayName)) {
            displayName = product.name;
          }
        }
        return (
          <div className="u-margin-bottom-2" key={accounts.id}>
            <AccountSummaryLinkCard
              accountAvailable={showAvailableBalance && getBalanceOf.availableBalance}
              accountBalance={getBalanceOf.currentBalance}
              accountName={displayName}
              accountNumber={accountNo.accNumber}
              onClick={() => {
                onAccountClick(accounts);
              }}
              sortcode={accountNo.sortcode}
            />
          </div>
        );
      })}
    </Column>
  );
};
AccountCardComponent.propTypes = {
  accountData: PropTypes.array,
  onAccountClick: PropTypes.func,
  poundSign: PropTypes.string,
};

export default AccountCardComponent;
